<template>
    <span> <slot name="activator" v-bind="{ active, loading, toggle }" /> </span>
</template>

<script>
import api from "@/api";
import { mapActions, mapMutations } from "vuex";

export default {
    props: {
        params: { type: Object, default: () => ({}) },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        likes() {
            return this.$store.state.likes;
        },
        like() {
            return (this.likes || []).find((item) => !Object.keys(this.params).some((key) => item[key] != this.params[key]));
        },
        active() {
            return !!this.like;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.init();
        },
    },
    methods: {
        ...mapActions(["getLikes"]),
        ...mapMutations(["setLikes"]),
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.$store.state.payload?._user && !this.likes) {
                    await this.getLikes();
                }
            } finally {
                this.loading = false;
            }
        },
        async toggle() {
            if (!this.$store.state.payload?._user) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                if (!!this.like) {
                    await api.v1.me.likes.delete({ _id: this.like._id });
                    this.setLikes({ likes: (this.likes || []).filter(({ _id }) => _id !== this.like._id) });
                    this.$emit("removed");
                } else {
                    const { like } = await api.v1.me.likes.post(this.params);
                    this.setLikes({ likes: [...(this.likes || []), like] });
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
